import { get } from '../Services/http';
import constants, { GOOGLEMAP_SET_ADVANCEDMARKER_OPEN, GOOGLEMAP_SET_ADVANCEDMARKER_ID, GOOGLEMAP_SET_AUTOCOMPLETE_PLACE } from '../constants';
export const RESELLER_LIST = 'RESELLER_LIST';
export const RESELLER_UPDATE = 'RESELLER_UPDATE';

export const loadDealerLocator = () =>(dispatch) => {
    return get('/api/dealerlocator/getorganizations?channelId=' + constants.channelId)
        .then((response) => response.json())
        .then((result) => dispatch(receive(result)));
      
};
export const receive = (result) => ({
    type: RESELLER_LIST,
    payload: result,
});
export const update = (result) => ({
    type: RESELLER_UPDATE,
    payload: result,
});

export const setAdvancedMarkerIsOpen = (value) => ({
    type: GOOGLEMAP_SET_ADVANCEDMARKER_OPEN,
    payload: {
        value
    },
});

export const setAdvancedMarkerId = (value) => ({
    type: GOOGLEMAP_SET_ADVANCEDMARKER_ID,
    payload: {
        value
    },
});

export const setAutocompletePlace = (value) => ({
    type: GOOGLEMAP_SET_AUTOCOMPLETE_PLACE,
    payload: {
        value
    },
});